module.exports = __webpack_public_path__ + "img/fixed_blockage.64916ac5.svg";